import {Component, Inject, OnInit} from '@angular/core';
import {
    MeterReadingEntryApi
} from 'app/shared/services/sdk/services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
    selector: 'app-charge-meter-readings',
    templateUrl: './charge.component.html',
    styleUrls: ['./charge.component.scss'],
    providers: [
        MeterReadingEntryApi
    ]
})
export class ChargeMeterReadingsComponent implements OnInit {

    chargeReadingsForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<ChargeMeterReadingsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        protected meterReadingEntryApi: MeterReadingEntryApi,
        private toastr: ToastrService,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.chargeReadingsForm = this.fb.group({
            id: [this.data.id, Validators.required],
            base_charge: [''],
            billing_rate: ['', Validators.required],
            billing_date: ['', Validators.required],
        });
    }



    onSubmit(){
        if(this.chargeReadingsForm.valid){
            this.meterReadingEntryApi.chargeReadings(this.chargeReadingsForm.getRawValue())
                .subscribe(res=>{
                    this.dialogRef.close(res);
                },err=>{
                    this.toastr.error(
                        'Meter readings could not be added'
                    );
                })
        }
    }

}
